import axios from "../axios-auth";
import orginal_axios from "axios";

export const stockAdjustmentService = {
    getStockAdjustmentList,
    saveStockAdjustment,
    getStockAdjustmentDetail,
    saveStockAdjustmentExcel,
    exportStockAdjustmentExcel,
    getAllStockAdjustmentList,
    getStockAdjustmentTemplate
}

function getStockAdjustmentList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/stock-adjustments", { params });

}

function saveStockAdjustment(stockAdjustment) {
    if (!stockAdjustment.id) {
        // new stock adjustment
        return axios.post("/auth/stock-adjustment", stockAdjustment);
    } else {
        // edit
        // return axios.put("/auth/stockin", stockIn);
    }
}

function getStockAdjustmentDetail(id) {
    return axios.get("/auth/stock-adjustment/" + id);
}

function getAllStockAdjustmentList(searchParams) {
    let params = {
        sort: "warehouseName,asc"
    };
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return axios.get("/auth/stock-adjustments", { params });
}

function saveStockAdjustmentExcel(file) {
    return axios.post('/auth/stock-adjustment-excel',
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}

function exportStockAdjustmentExcel(searchParams) {
    let params = {
    };
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stock-adjustment-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getStockAdjustmentTemplate() {
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stock-adjustment-excel-template",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    }); 
}